import ProyeccionModal from "./ProyeccionModal";
export default ProyeccionModal;